export default {
  state: {
    sections: ['levels', 'functions', 'types', 'models', 'capacity', 'attributes'],
    selectedSection: 'types',
    selectedLevelIds: [],
    selectedFunctionTypeIds: [],
    selectedTypeIds: [],
    selectedModelIds: [],
    selectedAttributesIds: [],
    selectedCapacity: 0,
    searchActiveNum: 0, // track api calls
  },
  mutations: {
    setSelectedSection(state, payload) {
      state.selectedSection = payload;
    },
    setSelectedTypeIds(state, payload) {
      const arr = [...state.selectedTypeIds];
      const index = arr.findIndex((item) => item === payload);
      if (index === -1) {
        arr.push(payload);
      } else {
        arr.splice(index, 1);
      }
      state.selectedTypeIds = arr;
    },
    setSelectedLevelIds(state, payload) {
      const arr = [...state.selectedLevelIds];
      const index = arr.findIndex((item) => item === payload);
      if (index === -1) {
        arr.push(payload);
      } else {
        arr.splice(index, 1);
      }
      state.selectedLevelIds = arr;
    },
    setSelectedFunctionTypeIds(state, payload) {
      const arr = [...state.selectedFunctionTypeIds];
      const index = arr.findIndex((item) => item === payload);
      if (index === -1) {
        arr.push(payload);
      } else {
        arr.splice(index, 1);
      }
      state.selectedFunctionTypeIds = arr;
    },
    setSelectedModelIds(state, payload) {
      const arr = [...state.selectedModelIds];
      const index = arr.findIndex((item) => item === payload);
      if (index === -1) {
        arr.push(payload);
      } else {
        arr.splice(index, 1);
      }
      state.selectedModelIds = arr;
    },
    setSelectedAttributeIds(state, payload) {
      const arr = [...state.selectedAttributesIds];
      const index = arr.findIndex((item) => item === payload);
      if (index === -1) {
        arr.push(payload);
      } else {
        arr.splice(index, 1);
      }
      state.selectedAttributesIds = arr;
    },
    setSelectedCapacity(state, payload) {
      state.selectedCapacity = payload;
    },
    activateSearch(state, payload) {
      if (payload) {
        state.searchActiveNum === 1 ? (state.searchActiveNum = 2) : (state.searchActiveNum = 1);
      } else {
        state.searchActiveNum = 0;
      }
    },
    clearAllFilters(state) {
      state.selectedTypeIds = [];
      state.selectedLevelIds = [];
      state.selectedFunctionTypeIds = [];
      state.selectedModelIds = [];
      state.selectedAttributesIds = [];
      state.selectedCapacity = 0;
      state.searchActivated = 0;
    },
    clearSelectedFilters(state, payload) {
      for (let i = 0; i < payload.length; i += 2) {
        const key = payload[i];
        const id = payload[i + 1];

        if (key === 'levels') {
          state.selectedLevelIds = state.selectedLevelIds.filter((levelId) => levelId !== id);
        } else if (key === 'types') {
          state.selectedTypeIds = state.selectedTypeIds.filter((typeId) => typeId !== id);
        } else if (key === 'functions') {
          state.selectedFunctionTypeIds = state.selectedFunctionTypeIds.filter(
            (functionTypeId) => functionTypeId !== id
          );
        } else if (key === 'models') {
          state.selectedModelIds = state.selectedModelIds.filter((modelId) => modelId !== id);
        } else if (key === 'attributes') {
          state.selectedAttributesIds = state.selectedAttributesIds.filter(
            (attributeId) => attributeId !== id
          );
        } else if (key === 'capacity' && state.selectedCapacity === id) {
          state.selectedCapacity = 0;
        }
      }
    },
  },
  actions: {
    setSelectedSection({ commit }, payload) {
      commit('setSelectedSection', payload);
    },
    setSelectedTypeIds({ commit }, payload) {
      commit('setSelectedTypeIds', payload);
    },
    setSelectedLevelIds({ commit }, payload) {
      commit('setSelectedLevelIds', payload);
    },
    setSelectedFunctionTypeIds({ commit }, payload) {
      commit('setSelectedFunctionTypeIds', payload);
    },
    setSelectedModelIds({ commit }, payload) {
      commit('setSelectedModelIds', payload);
    },
    setSelectedAttributeIds({ commit }, payload) {
      commit('setSelectedAttributeIds', payload);
    },
    setSelectedCapacity({ commit }, payload) {
      commit('setSelectedCapacity', payload);
    },
    activateSearch({ commit }, payload) {
      commit('activateSearch', payload);
    },
  },
};
